$ = require 'jquery'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
recup = require 'recup'
View = require 'view'

GuidedStepListComposerComponent = require 'views/list/guided-step-list-composer-component'

module.exports = class GuidedStepListComposerView extends View
  className: 'guided-step-container'

  initialize: ->
    @listenTo @modelCache, 'add:Card remove:Card change:Card:closed change:Card:idList', @frameDebounce @render
    @listenTo @modelCache, 'add:List remove:List change:List:closed reset:List',
      @frameDebounce @render
    @listenTo @model.viewState, 'change:showSidebar', @frameDebounce @render
    @listenTo @model, 'change:memberships', @frameDebounce @render

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      @getComposer()

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  render: ->
    @$reactRoot ?= $('<div></div>')
    @$el.append(@$reactRoot)
    @renderReactSection()

    if @model.editable()
      @$el.removeClass('fade hide')

    @

  getComposer: ->
    recup.render => recup.div =>
      recup.createElement GuidedStepListComposerComponent, {
        model: @model
        modelCache: @modelCache
      }

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super



// WEBPACK FOOTER //
// ./app/scripts/views/list/guided-step-list-composer-view.coffee